import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import _ from 'lodash'

import Aside from './aside'
import Calculator from './calculator'
import ReferralLink from '../profile/referral_link'
import jsonSelector from 'selectors/json'
import currentUserSelector from 'selectors/current_user'
import parametersSelector from 'selectors/parameters'

const Dashboard = ({ config_parameters, closed, current_user, abilities, user_signed_in }) => (
  <div>
    <h2>{I18n.t('dashboard.h')}</h2>
    <br />
    {closed && (
      <React.Fragment>
        <h2>The {config_parameters['coin.name']} Token Sale is closed.</h2>
        <br />
        <div className="text-center">
          <Translate value="main.info_block.description_show_ico_html" dangerousHTML />
        </div>
        <br />
      </React.Fragment>
    )}
    <br />
    <Grid container>
      <Grid item md={4} xs={12}>
        <h3>{I18n.t('dashboard.profile_details')}</h3>
        <div className="form-group">
          <label>{I18n.t('dashboard.registered_name')}</label>
          <span className="form-control">{current_user.name}</span>
        </div>
        <div className="form-group">
          <label>{I18n.t('dashboard.registered_email')}</label>
          <span className="form-control">{current_user.email}</span>
        </div>
        <div className="form-group">
          <label>{I18n.t('dashboard.registered_phone')}</label>
          <span className="form-control">{current_user.phone}</span>
        </div>
        <div>
          <Link to="/profile/edit">
            <Button raised color="primary">
              {I18n.t('dashboard.edit_button')}
            </Button>
          </Link>
        </div>
      </Grid>
      <Grid item md={8} xs={12}>
        <div className="gray-box dashboard-info">
          <Aside />
        </div>
        {abilities.can_user_buy_tokens && (
          <React.Fragment>
            <ReferralLink />
            <br />
            <div className="dashboard-calculator">
              <Calculator />
            </div>
            <br />
          </React.Fragment>
        )}
        <div className="dashboard-action">
          <div className="row">
            {abilities.can_user_make_deposits && (
              <div className="col-md-6 col-xs-12">
                <Link to="/deposits" className="btn btn-red">
                  {I18n.t('dashboard.deposit')}
                </Link>
              </div>
            )}
            {abilities.can_user_buy_tokens && (
              <div className="col-md-6 col-xs-12">
                <Link to="/tokens" className="btn btn-red-invert">
                  {I18n.t('dashboard.buy')}
                </Link>
              </div>
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  </div>
)

class DashboardContainer extends Component {
  componentDidMount() {
    const { push, closed } = this.props
    closed && push('/close-ico')
  }

  render() {
    return <Dashboard {...this.props} />
  }
}

const mapStateToProps = state => ({
  user_signed_in: !!state.users.authorization,
  config_parameters: parametersSelector(state),
  current_user: currentUserSelector(state),
  abilities: jsonSelector('infos.abilities')(state),
  closed: !_.isEmpty(state.infos.system.error)
})

const mapDispatchToProps = dispatch => bindActionCreators({ push }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)



// WEBPACK FOOTER //
// ./src/containers/pages/dashboard/index.js